export default __webpack_public_path__ + "static/media/640_private03-fr-mobile.c843020f.png";